import type { FilterGroupItem, FilterItem } from '@civilgrid/ui/utils';
import { getRawResearchStatuses } from '~/common/researchStatus';

/**
 * Copy of `filters` with every Research Status line expanded from its customer-facing label to
 * the raw statuses the server matches exactly: 'Equals' ORs them, 'Does Not Equal' ANDs them.
 * Apply to the outgoing request payload only — filter *state* keeps the label the user picked.
 */
export function toRawResearchStatusFilters(filters?: FilterGroupItem): FilterGroupItem | undefined {
  if (!filters) return filters;
  return { ...filters, items: filters.items.map(toRawResearchStatusItem) };
}

function toRawResearchStatusItem(item: FilterItem): FilterItem {
  if (item.type === 'group') return { ...item, items: item.items.map(toRawResearchStatusItem) };
  if (item.filterType?.id !== 'researchStatus' || !item.value) return item;

  const statuses = getRawResearchStatuses(item.value);
  if (statuses.length === 1) return { ...item, value: statuses[0] };
  return {
    type: 'group',
    id: item.id,
    operator: item.operatorType?.id === 'neq' ? 'and' : 'or',
    items: statuses.map((status, index) => ({ ...item, id: `${item.id}-${index}`, value: status })),
  };
}
